import { AccessTypeE } from '@generated/be';
import { LoggerOptions } from '../logger';

export enum EnvironmentName {
  Ivp = 'ivp', // internal dev (see .json in config folder)
  Tp = 'tp', // client test (see .json in config folder)
  Pp = 'pp', // client production (see .json in config folder)
  Int = 'int', // internal test (see .json in config folder)
  // Production = 'production', // internal env for production flag
  Local = 'local', // local dev
}

export interface Environment {
  name: EnvironmentName;
  production?: boolean;
  loginUrl: string;
  metadataDefaultValues?: Record<string, string | number | boolean | null | undefined>;
  loggerOptions?: LoggerOptions;
  customAccesses?: Array<AccessTypeE>;
  defaultSessionDialogLife: number;
  defaultSessionTime: number;
  chatbotUrl?: string;
  /**
   * Přihlášení v prostředí `local`: `mock` (výchozí) vývojovým tokenem ze `secret.jwtToken`, `cas` přes CAS jako na DEV
   * (`npm run start` = výchozí konfigurace serve `development-cas`, proxy.conf.js, docs/lokalni-prihlaseni-cas.md).
   */
  localAuth?: 'mock' | 'cas';
  secret: {
    jwtToken: string;
    [key: string]: string | number | boolean | null | undefined;
  };
}
